import React from 'react';
import { connect } from 'react-redux';
import IndexSummary from '../../../fundamental/common/index-summary';
import { REDUCER_NAME } from './reducer';

class PriceInfo extends React.Component {
  getPriceData = () => {
    const { price } = this.props;
    if (price) {
      return {
        MatchPrice: price.matchPrice,
        PriceChange: price.priceChange,
        PercentPriceChange: price.percentPriceChange,
        ReferencePrice: price.referencePrice,
        FloorPrice: price.floorPrice,
        CeilingPrice: price.ceilingPrice,
        tradingDate: price.tradingDate,
      };
    }

    return undefined;
  };

  render() {
    return <IndexSummary topContent={this.getPriceData()} />;
  }
}

const mapStateToProps = (state, { currentSearch }) => ({
  price: state[REDUCER_NAME].indicatorPrice[currentSearch.organCode],
});
export default connect(mapStateToProps)(PriceInfo);
